if (!customElements.get("single-product-variant-radios")) {
  class SingleProductVariantRadios extends VariantRadios {
    constructor() {
      super();
    }

    onVariantChange(e) {
      // only run if defaultSize is defined
      // if defaultSize is not defined, run the original function
      if (typeof this.dataset.defaultSize == "undefined") {
        super.onVariantChange(e);
        return;
      }

      this.updateOptions();
      this.setCurrentVariant();

      this.updateVariantStatuses();

      if (e.target.dataset.type == "Shade") {
        // set size selection to default size option
        this.setDefaultSize(e.target.value);
      }

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
      } else {
        if (this.currentVariant.available) {
          this.toggleAddButton(false, true, true);
        }

        this.updateURL();

        if (this.dataset.updateInfo === "true") {
          this.renderProductInfo(e.target);
          this.updateMedia();
        }

        this.updateVariantInput(e);
        // this.updateOptionLabel();
      }
    }

    setDefaultSize(currentShade) {
      const sizeOptions = this.querySelectorAll("input[data-type='Size']");
      sizeOptions.forEach((sizeOption) => {
        if (sizeOption.getAttribute("value") == this.dataset.defaultSize) {
          //check variant availability
          const variantData = this.getVariantData();
          const isDefaultSizeVariantAvailable = variantData
            .filter((variant) => variant.option1 == currentShade)
            .filter((variant) => variant.option2 == this.dataset.defaultSize)
            .map((variant) => variant.available);

          if (isDefaultSizeVariantAvailable[0] === true) {
            sizeOption.click();
          }
        }
      });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      // only run if defaultSize is defined
      // if defaultSize is not defined, run the original function
      if (typeof this.dataset.defaultSize == "undefined") {
        super.setInputAvailability(listOfOptions, listOfAvailableOptions);
        return;
      }
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
          input.classList.remove("disabled");
          input.removeAttribute("disabled");
          if (input.parentElement.querySelector(".tooltip")) {
            input.parentElement.querySelector(".tooltip").remove();
          }
        } else {
          input.classList.add("disabled");
          input.setAttribute("disabled", "disabled");

          if (!input.parentElement.querySelector(".tooltip")) {
            const tooltip = document.createElement("div");
            const node = document.createTextNode("Sold Out");
            tooltip.appendChild(node);
            tooltip.classList.add("tooltip");
            input.parentElement.appendChild(tooltip);
          }
        }
      });

      // select first available option
      if (listOfAvailableOptions.length == 1) {
        this.querySelector(
          "input[value='" + listOfAvailableOptions[0] + "']"
        ).click();
      }
    }
  }

  customElements.define(
    "single-product-variant-radios",
    SingleProductVariantRadios
  );
}
